import React, { Fragment } from 'react'
import Sidebar, { PrimaryNavLink } from '../layout/sidebar'
import ContentWrapper from '../layout/content_wrapper'
import { PageHeading } from '../shared/typography'
import SearchField from './field'
import { Checkbox, StackView, Text } from '@planningcenter/tapestry-react'
import ErrorUI from '../shared/error_ui'
import request from '../../api/request'
import Apps from '../../api/apps'
import Results from './results'

export default class Search extends React.Component {
  state = {
    isLoading: true,
    error: null,
    value: '',
    results: {},
    lastSearch: '',
    apps: Apps.map(app => {
      app.isSearching = true
      return app
    }),
  }

  componentDidMount() {
    this.setState(state => {
      const { query, app } = this.props.match.params
      state.value = decodeURIComponent(query)
      if (app) {
        state.apps = Apps.map(a => {
          a.isSearching = a.key === app
          return a
        })
      }
      return state
    }, this.search)
  }

  search = event => {
    if (event) {
      event.preventDefault()
    }
    const { value, apps, lastSearch } = this.state
    if (value === '') {
      return
    }
    this.setState({ lastSearch: value })
    if (lastSearch !== value) {
      this.props.history.replace(`/search/${encodeURIComponent(value)}`)
      this.setState({ results: {} })
    }
    let searches = []
    apps
      .filter(app => app.isSearching)
      .forEach(app => {
        searches.push(this._search(app.key, value))
      })
    Promise.all(searches).then(() => {
      this.setState({ isLoading: false })
    })
  }

  _search = (app, query) => {
    return request(`/${app}/v2/documentation/search?query=${query}`).then(
      response => {
        return new Promise(resolve => {
          this.setState(
            state => {
              state.results[app] = {
                app: app,
                data: response.data.data,
              }
              return state
            },
            () => {
              resolve(response)
            }
          )
        })
      }
    )
  }

  toggleSearch = id => {
    this.setState(state => {
      state.apps.forEach(app => {
        if (app.key === id) {
          app.isSearching = !app.isSearching
        }
      })
      return state
    }, this.search)
  }

  render() {
    const { error, results, value, apps } = this.state
    return (
      <Fragment>
        <Sidebar>
          {apps.map(app => {
            const handleParentClick = e => {
              if (e.target.localName === 'li') {
                this.toggleSearch(app.key)
              }
            }

            return (
              <PrimaryNavLink
                axis="horizontal"
                onClick={handleParentClick}
                key={app.key}
                cursor="pointer"
              >
                <Checkbox
                  name="checkbox"
                  value={app.name}
                  size="lg"
                  onChange={() => this.toggleSearch(app.key)}
                  checked={app.isSearching}
                  id={app.key}
                />
                <Text size={3} marginLeft={1} fontWeight="inherit">
                  {app.name}
                </Text>
              </PrimaryNavLink>
            )
          })}
        </Sidebar>

        <ContentWrapper>
          <ErrorUI error={error} onRetry={this.search}>
            <StackView axis="vertical" spacing={3}>
              <PageHeading>Search Results</PageHeading>

              <form onSubmit={this.search}>
                <SearchField
                  value={value}
                  onChange={event =>
                    this.setState({ value: event.target.value })
                  }
                />
              </form>

              {apps.map(app => {
                const result = results[app.key]
                if (result && app.isSearching) {
                  return <Results key={app.key} name={app.name} {...result} />
                } else {
                  return null
                }
              })}
            </StackView>
          </ErrorUI>
        </ContentWrapper>
      </Fragment>
    )
  }
}
